import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Link } from '@tanstack/react-router';
import { type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { apiErrorMessageKey } from '../../../lib/api';

export function OnboardingStartPending(): ReactElement {
    const { t } = useTranslation();
    return (
        <Box sx={{ mt: 2 }}>
            <Stack spacing={2} alignItems="center">
                <Typography variant="h6">{t('ONBOARDING.START.PENDING')}</Typography>
                <CircularProgress size={24} />
            </Stack>
        </Box>
    );
}

export function OnboardingStartError({ error }: { error: unknown }): ReactElement {
    const { t } = useTranslation();
    const message = t(apiErrorMessageKey(error, 'ERRORS.AUTH_LINK_INVALID'));
    return (
        <Box sx={{ mt: 2 }}>
            <Stack spacing={2} alignItems="center">
                <Alert severity="error">{message}</Alert>
                <Button component={Link} to="/register-company" variant="contained">
                    {t('ONBOARDING.START.RESTART')}
                </Button>
            </Stack>
        </Box>
    );
}
